import { Box, List, ListItemButton, TextField, Typography } from '@mui/material'
import { useIntl } from 'react-intl'
import { organizerApi } from '../../../modules/services/organizerService'
import { useState } from 'react'
import { useDebounce } from 'react-use'
import { format } from 'date-fns'

type EventSearchViewProps = {
  userId: number
  event: any  
  setEvent: (event: any) => void
}

export default function EventSearchView({
  userId,
  event,
  setEvent,
}: EventSearchViewProps) {
  const intl = useIntl()
  const [eventSearch, setEventSearch] =  useState<string | null>(null)

  const [transactionDataLazyFetch, { data: eventData, isLoading }] = organizerApi.useLazyGetOrganizerEventListQuery()

  useDebounce(
    () => {
      transactionDataLazyFetch({ search: eventSearch || '', userId, take: !eventSearch ? 2 : 5 });
    },
    750,
    [eventSearch]
  );

  return (
    <Box
      my={2}
      p={2}
      display='flex'
      flexDirection='column'
      justifyContent='center'
      width={1}
      alignItems='center'
      gap={2}
    >
      <Typography>
        {intl.formatMessage({ id: 'selectOrganizerEvent' })}
      </Typography>
      <TextField
        value={eventSearch}
        onChange={(e) => setEventSearch(e.target.value)}
        variant='outlined'
        color='warning'
        disabled={isLoading}
        fullWidth
        type='text'
        label={intl.formatMessage({
          id: 'eventNameSearchLabel'
        })}
        placeholder={intl.formatMessage({
          id: 'eventNameSearchLabel'
        })}
        dir='ltr'
        sx={{
          '.MuiInputBase-root.MuiInput-root:before': {
            borderBottom: '0px'
          },
          '.MuiInputBase-root.MuiInput-root:hover': {
            borderBottom: '0px'
          }
        }}
      />
      <List sx={{ width: '100%', maxHeight: '300px', overflowY: 'auto', gap: '12px' }}>
        {eventData?.list?.map((e: any) => (
          <ListItemButton color='warning' sx={{ border: '1px solid #e0e0e0', width: '100%', py: 1 }} key={e.eventLink} selected={e.eventLink === event?.eventLink} onClick={() => setEvent(e)} >
            <Box> 
              <Typography>
                {e.name}
              </Typography>
              <Typography>
                {format(new Date(e.startDate), 'dd/MM/yyyy HH:mm')} - {format(new Date(e.endDate), 'dd/MM/yyyy HH:mm')} 
              </Typography>
            </Box>
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
}
